import type { LoaderFunction, LoaderFunctionArgs } from 'react-router';

/**
 * loader 여러 개를 하나로 합친다. RR 은 라우트당 loader 가 하나라, 가드 + query 검증처럼
 * 여러 단계를 묶을 때 쓴다.
 *
 * 순서대로 await 하고, Response(`redirect` 등)가 나오면 거기서 멈춘다. 끝까지 통과하면
 * 마지막 non-null 값을 데이터로 쓴다 (가드는 null/redirect, 데이터는 schema parser 가 담당).
 */
export function composeLoaders(...loaders: LoaderFunction[]): LoaderFunction {
  return async (args: LoaderFunctionArgs) => {
    let last: unknown = null;
    for (const loader of loaders) {
      const result = await loader(args);
      if (result instanceof Response) return result;
      if (result != null) last = result;
    }
    return last;
  };
}
